import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.4/js/sparta-events-utility";
import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import spartaInputErrorUtility from "utilities/global/sparta-input-error-utility/7.2.1/js/sparta-input-error-utility";
import spartaInputUtility from "utilities/global/sparta-input-utility/13.0.5/js/sparta-input-utility";
import spartaMaskingUtility from "utilities/global/sparta-masking-utility/5.1.2/js/sparta-masking-utility";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.3/js/sparta-style-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.4/js/sparta-ui-layers-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.5/js/sparta-validation-framework";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.6/js/handlebars.runtime";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import _ from "utilities/vendor/lodash/4.13.1/js/lodash.custom.min";
import buttonHelper from "utilities/helpers/helpers-button/1.4.2/js/helpers-button";
import select from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import helpersSelect from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import selectHelper from "utilities/helpers/helpers-select/3.4.3/js/helpers-select";
import spartaHelpers from "utilities/helpers/helpers-sparta/2.3.5/js/helpers-sparta";
import textInput from "utilities/helpers/helpers-text-inputs/3.11.1/js/helpers-text-inputs";
import spartaTemplates from "modules/global/zip-code-selector-module/5.1.4/js/templates";
import "css!modules/global/zip-code-selector-module/5.1.4/css/zip-code-selector-module.scss.css";
/* global Module spaParams spartaGlobalFunctions spartaEventsUtility spartaUILayersUtility
   spartaValidationFramework spartaInputErrorUtility spartaStoreUtility */

/**
 * zip-code-selector-module
 * module_js_id: zipCodeSelectorModuleJS
 *
 * Copyright (c) 2017-8-7 Sunny Singh (zktuuyv)
 */

const openZipModalResponse = (modalId, input) => {
  const $layer = $(modalId);
  const $header = $layer.find('h3').attr('tabindex', '-1');
  const $input = $layer.find(input);
  $input.focus();
  $layer.on('focusout', (event) => {
    if (!$layer.find(event.relatedTarget || document.activeElement).length) {
      $header.focus();
    }
  });
  $header.on('keydown', (event) => {
    if ([39, 40].indexOf(event.keyCode) !== -1) {
      event.preventDefault();
      $input.focus();
    }
  });
};

/**
 * @class zipCodeSelectorModuleJS
 * @returns {Object} instance of module
 */
export default class zipCodeSelectorModuleJS extends Module {
  /**
   * Set common properties.
   */
  constructor(options) {
    super(options);

    // Get cookie data
    const { spartaGetCookie } = spartaGlobalFunctions;
    this.stateFromStateCookie = spartaStoreUtility._getState();
    this.boaGeographicDataCookie = spartaGetCookie('boa_geographic_data');
    this.boaGeographicDataCookieArray = this.boaGeographicDataCookie ? this.boaGeographicDataCookie.split('|') : [];
    this.zipFromGeoCookie = this.boaGeographicDataCookieArray[0] || '';
    this.stateFromGeoCookie = this.boaGeographicDataCookieArray[4] || '';
    this.countyGroupCookie = spartaGetCookie('county_group');
    this.settings.origBOAGeoCookie = this.boaGeographicDataCookie;
    this.isFirstLoadStorageKey = 'boa_is_zip_first_load';
    this.isFirstLoad = this.Store.getPersisted(this.isFirstLoadStorageKey)
      ? this.Store.getPersisted(this.isFirstLoadStorageKey)
      : 'true';
    this.flowTypeValue = this.params.isSmallBusinessFlow ? 'smallbusiness' : 'consumer';
    this._handleGoButtonClick = this._handleGoButtonClick.bind(this);

    this.settings.debugParams = [
      {
        state: 'NC',
        fipsStateCode: '12',
        countyName: 'Alchua',
        fipsCountyCode: '001',
        pricingFipsStateCode: '19',
        pricingFipsCountyCode: '120',
      },
      {
        state: 'NC',
        fipsStateCode: '12',
        countyName: 'Testing',
        fipsCountyCode: '001',
        pricingFipsStateCode: '10',
        pricingFipsCountyCode: '180',
      },
    ];

    this.settings.lleParams = [
      {
        zip: '23219',
        state: 'NC',
        fipsStateCode: '12',
        countyName: 'Alchua',
        fipsCountyCode: '001',
        pricingFipsStateCode: '14',
        pricingFipsCountyCode: '150',
      },
    ];
  }

  /**
   * Initialize module.
   * @returns {undefined}
   */
  init() {
    const $target = $('#zipCodeSelectorModule', this.applicationContainer);
    this.settings.$target = $target;

    $target.spartaInputs({ validate: false });

    // Create utility shortcuts
    this.Events = spartaEventsUtility;
    this.Layers = spartaUILayersUtility;
    this.Store = spartaStoreUtility;
    this.Validation = spartaValidationFramework.fn.core; // must be after $target.spartaInputs()

    this._bindValidationRules();

    // Allow enter key on input to click go button
    $target.find('input').on('keypress', (event) => {
      if (event.keyCode === 13) {
        event.preventDefault();
        $(event.target).closest('form').find('a').click();
        $(event.target).closest('form').find('button').click();
      }
    });

    // Bind click handlers
    if ($target.find('.sparta-button a').length) {
      $target.find('.sparta-button a').on('click', this._handleGoButtonClick);
    }
    if ($target.find('.sparta-button button').length) {
      $target.find('.sparta-button button').on('click', this._handleGoButtonClick);
    }
    $target.find('.modal-sparta-button a').on('click', this._handleGoButtonClick);

    // If we have zip value from the start then set it at the bottom of the page
    if (this.zipFromGeoCookie.length !== 0 && this.stateFromStateCookie) {
      this._setZip(this.zipFromGeoCookie);
    }

    let isFlowSwitch = false;
    if (this.boaGeographicDataCookieArray.length) {
      if (this.boaGeographicDataCookieArray.length === 6) {
        const smallBusiness = 'smallbusiness';
        const pricingData = this.boaGeographicDataCookieArray[5];
        const pricingDataArr = pricingData.split('-');
        const pricingFlowType = pricingDataArr[0].toLowerCase();
        const isSmallBusinessFlowCookie = pricingFlowType === smallBusiness;
        const url = window.location.href.toLowerCase();
        isFlowSwitch = !(url.indexOf(smallBusiness) !== -1
          ? isSmallBusinessFlowCookie
          : pricingFlowType === 'consumer');
      }
    }

    if (
      (isFlowSwitch && this.zipFromGeoCookie.length !== 0 && this.stateFromStateCookie) ||
      (this.boaGeographicDataCookieArray.length !== 0 && this.boaGeographicDataCookieArray.length === 5)
    ) {
      this.updateGeoCookieWithPricingData(this.boaGeographicDataCookieArray);
    }

    if (
      this.zipFromGeoCookie === '' ||
      this.stateFromStateCookie === '' ||
      (this.params.alwaysShowModal === true && this.isFirstLoad === 'true')
    ) {
      // show modal if no cookies are set, or if alwaysShowModal is set and we're not reloading
      this.Layers.openLayer($('#zipSelectModal'));
      this.Events.pub('modal-opened:zip-code-selector-module', {
        modalEl: $('#zipSelectModal'),
      });
      openZipModalResponse('#zipSelectModalSpartaUILayer', '.spa-input-text');
    } else if (this.stateFromGeoCookie === '' || this.settings.origBOAGeoCookie === '') {
      this._setZip(this.zipFromGeoCookie);
      this._obtainCounties(this.zipFromGeoCookie);
    } else if (
      this.settings.origBOAGeoCookie.length !== 0 &&
      (this.countyGroupCookie.indexOf('null') > -1 || this.countyGroupCookie === '')
    ) {
      const postData = {
        fipsStateCode: this.boaGeographicDataCookieArray[2],
        fipsCountyCode: this.boaGeographicDataCookieArray[3],
        countyName: this.boaGeographicDataCookieArray[1],
      };

      if (this.boaGeographicDataCookieArray.length === 6) {
        const pricingData = this.boaGeographicDataCookieArray[5];
        const pricingDataArr = pricingData.split('-');
        postData.pricingFipsStateCode = pricingDataArr[1];
        postData.pricingFipsCountyCode = pricingDataArr[2];
        postData.flowType = this.flowTypeValue;
      }

      // make ajax call for county group
      $.when(this._fipsCountyGroupAjax(postData)).then(
        // success
        () => {
          this._reloadPage();
        },

        // failure
        (xhr) => {
          this._ajaxFipsCountyGroupFailure(xhr);
          this._reloadPage();
        },
      );
    }
  }

  /**
   * On go button click validate form and make ajax call for counties if valid.
   * @param {Object} event jQuery event object.
   * @returns {undefined}
   */
  _handleGoButtonClick(event) {
    const $button = $(event.target);
    const $form = $button.closest('form');
    const value = $form.find('input').val();

    if (this._isFormValid($form)) {
      this._setZip(value);
      this._obtainCounties(value, $form);
    }
  }

  /**
   * Bind validation rules that were declared in the JCR.
   * Also allow for custom validation rules when a testFunction is defined in the JCR.
   * @returns {undefined}
   */
  _bindValidationRules() {
    const { $target } = this.settings;
    const formValidations = {};

    $target.find('[data-validation-rules]').each((index, field) => {
      const $field = $(field);
      const id = $field.attr('id');
      const rules = $field.data('validation-rules');
      const testFunctions = {};

      formValidations[id] = rules;

      if (rules.change && rules.change.customFunction) {
        const { testFunction, errorMessage } = rules.change.customFunction;

        formValidations[id].change.customFunction = {
          parameters: [testFunctions[testFunction].bind(this, $field)],
          errorMessage,
        };
      }

      $field.removeAttr('data-validation-rules');
    });

    this.Validation.bindValidationRules(formValidations, true);
  }

  /**
   * Check if form is valid.
   * @param {Object} $form jQuery DOM node.
   * @returns {Boolean} Is form valid?
   */
  _isFormValid($form) {
    const $input = $form.find('input');
    const isFormFilled = this.Validation.validateRequiredFields($input);

    if (!isFormFilled) {
      return false;
    }

    $input.trigger('change');

    if ($input.val().length !== 5) {
      return false;
    }

    return true;
  }

  /**
   * Set default in zip code input.
   * @param {*} zip Selected zip code.
   * @returns {undefined}
   */
  _setZip(zip) {
    const { $target } = this.settings;
    const $input = $target.find('#zipCodeInputField');
    $input.val(zip).focusin().focusout();
  }

  /**
   * Runs ajax and if success will pop up counties modal if more than one county.
   * @param {Number} zip Zip code.
   * @param {Object} $formElement jQuery DOM node.
   * @returns {undefined}
   */
  _obtainCounties(zip, $formElement) {
    const { $target, debugParams } = this.settings;
    const $form = $formElement || $target;
    const aps2Domain = spaParams.siteParams.aps2Domain;
    const url = `${aps2Domain}/salesservices/getCountiesByFlowType?zipCode=${encodeURIComponent(zip)}&flowType=${
      this.flowTypeValue
    }`;
    const getPost = 'GET';
    const debugData = debugParams;

    this._setSpinnerVisibility(true, $form);

    $.when(this._ajaxPromise(url, getPost, '', debugData)).then(
      // success
      (response) => {
        if (!$.isArray(response)) {
          this._ajaxCountyFail({}, zip, $form);
          this._closeZipSelectModal();
        } else {
          const state = response[0].state;
          const numberOfCounties = response.length;

          $target.find('#countySelectModal select').find('option:gt(0)').remove();

          // set post data for ajax call
          const postData = {
            fipsStateCode: response[0].fipsStateCode,
            fipsCountyCode: response[0].fipsCountyCode,
            countyName: response[0].countyName,
            pricingFipsStateCode: response[0].pricingFipsStateCode,
            pricingFipsCountyCode: response[0].pricingFipsCountyCode,
            flowType: this.flowTypeValue,
          };

          // populate select options
          for (let i = 0; i < response.length; i += 1) {
            const option = `<option value="${response[i].fipsStateCode}|${response[i].fipsCountyCode}|${response[i].countyName}|${response[i].pricingFipsStateCode}|${response[i].pricingFipsCountyCode}"
              >${response[i].countyName}, ${state}</option>`;

            $target.find('#countySelectModal select').append(option);
          }

          if (numberOfCounties > 1) {
            this.Layers.openLayer($target.find('#countySelectModal'));
            openZipModalResponse('#countySelectModal', '.spa-input-select');

            // click go on county modal button
            $('#go-button-county-modal')
              .off()
              .on('click', (event) => {
                event.preventDefault();

                // get selected input
                const selectedValue = $('.spa-input-select.county-select option:selected').val();

                if (selectedValue.length) {
                  this._setSpinnerVisibility(true, $form);

                  // get selected input and set post data object
                  const optionValue = selectedValue.split('|');
                  const fipsState = optionValue[0];
                  const fipsCounty = optionValue[1];
                  const countyName = optionValue[2];
                  const pricingFipsStateCode = optionValue[3];
                  const pricingFipsCountyCode = optionValue[4];

                  postData.fipsStateCode = fipsState;
                  postData.fipsCountyCode = fipsCounty;
                  postData.countyName = countyName;
                  postData.pricingFipsStateCode = pricingFipsStateCode;
                  postData.pricingFipsCountyCode = pricingFipsCountyCode;

                  // make ajax call to set fip state county cookie
                  $.when(this._fipsCountyGroupAjax(postData)).then(
                    // success
                    () => {
                      this._setSpinnerVisibility(false, $form);
                      this.Layers.closeLayer();
                      this.Events.pub('modal-closed:zip-code-selector-module');
                      this._reloadPage();
                    },

                    // failure
                    (xhr) => {
                      this._setSpinnerVisibility(false, $form);
                      this._ajaxFipsCountyGroupFailure(xhr);
                      this.Layers.closeLayer();
                      this.Events.pub('modal-closed:zip-code-selector-module');
                      this._reloadPage();
                    },
                  );
                } else {
                  // No county was selected in drop down
                  const $modalForm = $(event.target).closest('form');
                  const $selectField = $modalForm.find('select');
                  this.Validation.validateRequiredFields($selectField);
                }
              });
          } else {
            // only one county was returned
            // make ajax call to county group
            $.when(this._fipsCountyGroupAjax(postData)).then(
              // success
              (newResponse) => {
                if (!newResponse || Object.keys(newResponse).length === 0) {
                  this._ajaxFipsCountyGroupFailure();
                }
                this._reloadPage();
              },

              // failure
              (xhr) => {
                this._ajaxFipsCountyGroupFailure(xhr);
                this._reloadPage();
              },
            );

            this._setZip(zip);
            this._closeZipSelectModal();
          }
        }

        this._setSpinnerVisibility(false, $formElement);
      },

      // failure
      (xhr) => {
        this._setSpinnerVisibility(false, $form);

        if (spaParams.siteParams.testKey === 'local') {
          this._ajaxCountyFailDebug($form);
        } else {
          this._ajaxCountyFail(xhr, zip, $form);
        }
      },
    );
  }

  /**
   * Make fips county group ajax.
   * @param {Object} data Body object.
   * @returns {Object} Promise object.
   */
  _fipsCountyGroupAjax(data = {}) {
    const { aps2Domain } = spaParams.siteParams;
    const baseUrl = `${aps2Domain}/salesservices/getCountyGroup`;
    const getPost = 'POST';
    const hash = this.constructor._getQueryParams();
    const url = hash.debug === 'true' ? `${baseUrl}?mock=pwd~sitteam|piper~pricinglocation` : baseUrl;

    return this._ajaxPromise(url, getPost, data);
  }

  /**
   * Runs ajax and returns a promise that is either resolved or rejected.
   * @param {String} url Request URL.
   * @param {String} getPost GET or POST.
   * @param {Object} data Request body.
   * @param {Object} debugData Debug data object.
   * @returns {Object} Promise object.
   */
  _ajaxPromise(url, getPost, data = {}, debugData = {}) {
    const dfd = $.Deferred();
    const hash = this.constructor._getQueryParams();
    const multCounty = hash.multCounty === 'true';

    const ajaxParams = {
      url,
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(data),
      method: getPost,
      crossDomain: true,
      success: (response) => {
        this.Events.pub('geo-retrieved:zip-code-selector-module', response);
        dfd.resolve(response);
      },
      error: (xhr) => {
        if (spaParams.siteParams.testKey === 'local') {
          if (multCounty) {
            this.Events.pub('geo-retrieved:zip-code-selector-module', debugData);
            dfd.resolve(debugData);
          } else if (debugData.length > 1) {
            this.Events.pub('geo-retrieved:zip-code-selector-module', debugData.slice(0, 1));
            dfd.resolve(debugData.slice(0, 1));
          } else {
            dfd.resolve(debugData);
          }
        } else {
          this.Events.pub('geo-error:zip-code-selector-module', xhr);
          dfd.reject(xhr);
        }
      },
    };

    // If a get then we don't need certain keys
    if (getPost.toUpperCase() === 'GET') {
      delete ajaxParams.contentType;
      delete ajaxParams.data;
    }

    $.ajax(ajaxParams);

    return dfd.promise();
  }

  /**
   * Handle failed county response.
   * @param {Object} xhr jQuery ajax object.
   * @param {String} zip Zip code.
   * @param {Object} $form jQuery DOM node.
   * @returns {undefined}
   */
  _ajaxCountyFail(xhr, zip, $form) {
    const { $target } = this.settings;
    const errorMessages = {
      400: 'Please enter a valid zip',
      default: 'Service is down',
    };

    const showError = (key = 'default') => {
      spartaInputErrorUtility.updateInlineError(true, {
        field: $form.find('input'),
        label: $form.find('label'),
        message: errorMessages[key],
      });
    };

    switch (xhr.status) {
      case 400: {
        showError(400);
        break;
      }
      case 503: {
        showError();
        if (!this.params.noErrorPage) {
          window.location.replace(`${window.location}error`);
        }
        break;
      }
      case 504: {
        showError();
        break;
      }
      default: {
        showError();
        if (!this.params.noErrorPage) {
          window.location.replace(`${window.location}error`);
        }
        break;
      }
    }

    // clear out input
    $target.find('input[id*="zip"]').val('');

    // remove cookie
    this.constructor._removeCookies();
  }

  /**
   * Handle failed county response while debugging.
   * @returns {undefined}
   */
  _ajaxCountyFailDebug() {
    const { spartaSetCookie } = spartaGlobalFunctions;
    const defaultData = this.settings.lleParams[0];
    const { state, zip, countyName, fipsStateCode, fipsCountyCode, fipsCountyName } = defaultData;

    if (spaParams.siteParams.testKey !== 'local') return;

    this.Store._setState(defaultData.state);
    spartaSetCookie('boa_geographic_data', `${zip}|${countyName}|${fipsStateCode}|${fipsCountyCode}|${state}`, 1);

    const postData = { fipsStateCode, fipsCountyCode, fipsCountyName };

    $.when(this._fipsCountyGroupAjax(postData)).then(
      // success
      () => {
        this._reloadPage();
      },

      // failure
      (xhr) => {
        this._ajaxFipsCountyGroupFailure(xhr);
        this._reloadPage();
      },
    );

    this._setZip(zip);
    this._closeZipSelectModal();
  }

  /**
   * Handle piper county group failure.
   * @returns {undefined}
   */
  _ajaxFipsCountyGroupFailure() {
    if (spaParams.siteParams.testKey === 'local') {
      this._ajaxCountyFailDebug();
    }
  }

  /**
   * Allow showing or hiding of spinner within button.
   * @param {Boolean} isVisible Show or hide spinner.
   * @param {Object} $form jQuery DOM node.
   * @returns {undefined}
   */
  _setSpinnerVisibility(isVisible, $form) {
    const { $target } = this.settings;
    const selector = '.sparta-button a, .sparta-button button, .modal-sparta-button a';
    const spinnerClass = 'zip-code-selector-spinner';
    const $button = $form ? $form.find(selector) : $target.find(selector);

    if (isVisible) {
      $button.append(`<span class="${spinnerClass}" />`);
    } else {
      $button.find(`.${spinnerClass}`).remove();
    }
  }

  /**
   * Close zip select modal layer.
   * @returns {undefined}
   */
  _closeZipSelectModal() {
    const $zipSelectModal = $('#zipSelectModalSpartaUILayer', this.applicationContainer);
    const open = $zipSelectModal.css('display') === 'block';
    if (open) {
      this.Layers.closeLayer('zipSelectModalSpartaUILayer');
      this.Events.pub('modal-closed:zip-code-selector-module');
    }
  }

  /**
   * Get an object of query parameters.
   * @returns {Object} Hash object.
   */
  static _getQueryParams() {
    const queryParms = (window.location.search || '').substring(1).split('&');
    const hash = {};

    for (let i = 0; i < queryParms.length; i += 1) {
      const holder = queryParms[i].split('=');
      hash[holder[0]] = holder[1];
    }

    return hash;
  }

  /**
   * Delete all zip code related cookies.
   * @returns {undefined}
   */
  static _removeCookies() {
    const { spartaSetCookie } = spartaGlobalFunctions;
    spartaSetCookie('boa_geographic_data', '', -1);
    spartaSetCookie('county_group', '', -1);
    spartaSetCookie('state', '', -1);
  }

  /**
   * Reload page logic.
   * @returns {undefined}
   */
  _reloadPage() {
    const { origBOAGeoCookie } = this.settings;
    let currBOAGeoCookie = spartaGlobalFunctions.spartaGetCookie('boa_geographic_data');

    // cleanup
    this.settings.origBOAGeoCookie = origBOAGeoCookie === 'null' ? '' : origBOAGeoCookie;
    currBOAGeoCookie = currBOAGeoCookie === 'null' ? '' : currBOAGeoCookie;

    if (spaParams.siteParams.testKey !== 'local') {
      if (
        (origBOAGeoCookie !== currBOAGeoCookie || !this.stateFromStateCookie) &&
        this.params.alwaysShowModal !== true
      ) {
        this.Store.persist(this.isFirstLoadStorageKey, 'false');
        window.location.reload();
      } else {
        this.Store.removePersisted(this.isFirstLoadStorageKey);
      }
    }
  }

  updateGeoCookieWithPricingData(boaGeographicCookieArr) {
    const { $target, debugParams } = this.settings;
    const aps2Domain = spaParams.siteParams.aps2Domain;
    const zip = boaGeographicCookieArr[0];
    const oldCountyName = boaGeographicCookieArr[1];
    const url = `${aps2Domain}/salesservices/getCountiesByFlowType?zipCode=${encodeURIComponent(zip)}&flowType=${
      this.flowTypeValue
    }`;

    const getPost = 'GET';
    $.when(this._ajaxPromise(url, getPost, '', debugParams)).then(
      (response) => {
        if ($.isArray(response)) {
          let selectedCounty =
            response.length > 1 ? response.filter((countyDto) => countyDto.countyName === oldCountyName) : response;

          const postData = {
            fipsStateCode: selectedCounty[0].fipsStateCode,
            fipsCountyCode: selectedCounty[0].fipsCountyCode,
            countyName: selectedCounty[0].countyName,
            pricingFipsStateCode: selectedCounty[0].pricingFipsStateCode,
            pricingFipsCountyCode: selectedCounty[0].pricingFipsCountyCode,
            flowType: this.flowTypeValue,
          };

          $.when(this._fipsCountyGroupAjax(postData)).then(
            // success
            () => {},

            // failure
            (xhr) => {},
          );
        }
      },

      (xhr) => {
        // if fail, Do nothing
      },
    );
  }
}
